import Vue from "vue";
import Router from "vue-router";
import Person from "@/views/Person/Person";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: '/login',
      component: () => import("@/views/index"),
      children: [
        {
          path: "/login",
          component: () => import("@/views/Login/Login"),
        }
      ]
    },
    {
      path: "/layout",
      component: () => import("@/views/Layout/Layout"),
      children: [
        {
          path: "/person",
          name: "Person",
          component: Person
        }
      ]
    },
    {
      path: "/apply",
      name: "Apply",
      component: () => import("@/views/Apply/Apply"),
      meta: {
        keepAlive: false // 该路由会被缓存
      }
    },
    {
      path: "/pdf",
      name: "Pdf",
      component: () => import("@/components/pdfView/pdf"),
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js